export const LOAD_INITIAL_DATA = 'LOAD_INITIAL_DATA'
export const PROGRESS_INIT_STATE = 'PROGRESS_INIT_STATE'
export const REGRESS_INIT_STATE = 'REGRESS_INIT_STATE'

export const INIT_STATE = {
    SET_TRIP_LENGTH: 'SET_TRIP_LENGTH',
    ADD_DESTINATION: 'ADD_DESTINATION',
    COMPLETE: 'COMPLETE'
}

export const INIT_STATE_ORDER = [
    INIT_STATE.SET_TRIP_LENGTH,
    INIT_STATE.ADD_DESTINATION,
    INIT_STATE.COMPLETE,
]

export function loadInitialData(data) {
    return {
        type: LOAD_INITIAL_DATA,
        ignoreJOTChange: true,
        data,
    }
}

export function progressInitState() {
    return {
        type: PROGRESS_INIT_STATE,
    }
}

export function regressInitState() {
    return {
        type: REGRESS_INIT_STATE,
    }
}
